import { GameSettings } from "./types";
import { contentTypeIds } from "../types";

export const clashroyale: GameSettings = {
  enabledTabs: ["news", "community", "esport", "blog"],
  enabledLocales: [
    "en",
    "zh",
    "zh-hans",
    "fr",
    "de",
    "id",
    "it",
    "ja",
    "ko",
    "pt",
    "ru",
    "es",
  ],
  referenceWidth: 412,

  tabContentFallbacks: {
    community: {
      id: ["en"],
      ru: ["en"],
    },

    esport: {
      id: ["en"],
      ru: ["en"],
    },
  },

  enabledNotificationTypes: ["standard"],
  availableCategories: [
    {
      id: "esport-news",
      name: {
        en: "News",
        ar: "أخبار",
        nl: "Nieuws",
        fi: "Uutiset",
        fr: "Actualités",
        de: "News",
        id: "Berita",
        it: "Notizie",
        ja: "ニュース",
        ko: "소식",
        ms: "Berita",
        pt: "Notícias",
        ru: "Новости",
        pl: "Aktualności",
        es: "Noticias",
        th: "ข่าว",
        tr: "Haberler",
        vi: "Tin tức",
        zh: "最新情報",
      },
      color: "#005fae",
    },
    {
      id: "news",
      name: {
        en: "News",
        ar: "أخبار",
        nl: "Nieuws",
        fi: "Uutiset",
        fr: "Actualités",
        de: "News",
        id: "Berita",
        it: "Notizie",
        ja: "ニュース",
        ko: "소식",
        ms: "Berita",
        pt: "Notícias",
        ru: "Новости",
        pl: "Aktualności",
        es: "Noticias",
        th: "ข่าว",
        tr: "Haberler",
        vi: "Tin tức",
        zh: "最新情報",
      },
      color: "#4549a8",
    },
    {
      id: "release-notes",
      name: {
        en: "Release Notes",

        ar: "ملاحظات الإصدار",
        nl: "Release-opmerkingen",
        fi: "Julkaisutiedot",
        fr: "Notes de patch",
        de: "Versionshinweise",
        id: "Catatan Rilis",
        it: "Note di rilascio",
        ja: "リリース情報",
        ko: "새 소식",
        ms: "Nota Keluaran",
        pt: "Notas de lançamento",
        ru: "Информация о версии",
        pl: "O wersji",
        es: "Notas de actualización",
        th: "รายละเอียดเปิดตัว",
        tr: "Sürüm Notları",
        vi: "Thông tin về phiên bản",
        zh: "更新說明",
      },
      color: "#519f5c",
    },
    {
      id: "fun",
      name: {
        en: "Fun",

        ar: "تسالي",
        nl: "Leuk",
        fi: "Hupi",
        fr: "Fun",
        de: "Spaß",
        id: "Keseruan",
        it: "Divertimento",
        ja: "エンタメ",
        ko: "재미",
        ms: "Hiburan",
        pt: "Diversão",
        ru: "Развлечения",
        pl: "Rozrywka",
        es: "Diversión",
        th: "เรื่องสนุกๆ",
        tr: "Eğlence",
        vi: "Giải trí",
        zh: "趣味",
      },
      color: "#b588ff",
    },
    {
      id: "art",
      name: {
        en: "Art",

        ar: "أعمال فنية",
        nl: "Kunst",
        fi: "Taide",
        fr: "Art",
        de: "Artwork",
        id: "Seni",
        it: "Arte",
        ja: "アート",
        ko: "아트",
        ms: "Seni",
        pt: "Arte",
        ru: "Арт",
        pl: "Grafika",
        es: "Arte",
        th: "งานอาร์ต",
        tr: "Görseller",
        vi: "Tác phẩm nghệ thuật",
        zh: "藝術",
      },
      color: "#ff8b04",
    },
    {
      id: "community",
      name: {
        en: "Community",

        ar: "مجتمع اللعبة",
        nl: "Community",
        fi: "Yhteisö",
        fr: "Communauté",
        de: "Community",
        id: "Komunitas",
        it: "Community",
        ko: "커뮤니티",
        ms: "Komuniti",
        pt: "Comunidade",
        ru: "Сообщество",
        pl: "Społeczność",
        es: "Comunidad",
        th: "ชุมชน",
        tr: "Oyuncular",
        vi: "Cộng đồng",
        zh: "社群",
      },
      color: "#dc563f",
    },
    {
      id: "esports",
      name: {
        en: "Esports",

        ar: "المسابقات الإلكترونية",
        nl: "E-sports",
        fi: "E-urheilu",
        fr: "E-sport",
        de: "E-Sports",
        id: "Esports",
        it: "Esports",
        ja: "eスポーツ",
        ko: "e스포츠",
        ms: "E-sukan",
        pt: "E-sports",
        ru: "Киберспорт",
        pl: "E-sport",
        es: "eSports",
        th: "อีสปอร์ต",
        tr: "E-spor",
        vi: "Thể thao điện tử",
        zh: "賽事",
      },
      color: "#19eb86",
    },
    {
      id: "highlights",
      name: {
        en: "Highlights",

        ar: "أبرز اللحظات",
        nl: "Hoogtepunten",
        fi: "Kohokohdat",
        fr: "Temps forts",
        de: "Highlights",
        id: "Sorotan",
        it: "Momenti salienti",
        ko: "하이라이트",
        ms: "Sorotan",
        pt: "Destaques",
        ru: "Лучшие моменты",
        pl: "Najważniejsze",
        es: "Lo más destacado",
        th: "ไฮไลต์",
        tr: "Öne Çıkanlar",
        vi: "Nổi bật",
        zh: "精彩時刻",
      },
      color: "#426bbd",
    },
    {
      id: "official-art",
      name: {
        en: "Official art",
        ar: "أعمال فنية رسمية",
        nl: "Officiële kunst",
        fi: "Virallinen taide",
        fr: "Art officiel",
        de: "Offizielles Artwork",
        id: "Seni Resmi",
        it: "Illustrazioni ufficiali",
        ja: "公式アート",
        ko: "공식 아트",
        ms: "Seni rasmi",
        pt: "Arte oficial",
        ru: "Официальный арт",
        pl: "Oficjalna grafika",
        es: "Arte oficial",
        th: "งานอาร์ตแบบเป็นทางการ",
        tr: "Resmi Görseller",
        vi: "Tác phẩm nghệ thuật chính thức",
        zh: "官方作品",
      },
      color: "#426bbd",
    },
    {
      id: "strategy",
      name: {
        en: "Strategy",
        ar: "إستراتيجيات",
        nl: "Strategie",
        fi: "Strategia",
        fr: "Stratégie",
        de: "Strategie",
        id: "Strategi",
        it: "Strategia",
        ja: "戦略",
        ko: "전략",
        ms: "Strategi",
        pt: "Estratégia",
        ru: "Стратегия",
        pl: "Strategia",
        es: "Estrategia",
        th: "กลยุทธ์",
        tr: "Strateji",
        vi: "Chiến thuật",
        zh: "攻略",
      },
      color: "#cc3e48",
    },
  ],
  esport: {
    enableCarouselTitle: true,
  },

  enabledComposePages: ["news", "events"],

  // TODO: Add esport sizes here and check
  resolutions: {
    [contentTypeIds.carouselEventEntry]: {
      carouselImage: {
        width: 960,
        height: 764,
      },
    },
    [contentTypeIds.carouselEventPollEntry]: {
      carouselImage: {
        width: 960,
        height: 764,
      },

      option1Image: {
        width: 300,
        height: 400,
      },
      option2Image: {
        width: 300,
        height: 400,
      },
      option3Image: {
        width: 300,
        height: 400,
      },
      option4Image: {
        width: 300,
        height: 400,
      },
      option5Image: {
        width: 300,
        height: 400,
      },
    },
    [contentTypeIds.carouselEventPollTargetsEntry]: {
      carouselImage: {
        width: 960,
        height: 764,
      },
    },
    [contentTypeIds.esportCarouselEventEntry]: {
      carouselImage: {
        width: 960,
        height: 764,
      },
    },
    [contentTypeIds.esportLiveEventEntry]: {
      carouselImage: {
        width: 960,
        height: 764,
      },
      eventPromotionLogo: {
        width: 128,
        height: 128,
      },
    },
    [contentTypeIds.newsEntryExternalLink]: {
      linkThumbnail: {
        width: 960,
        height: 540,
      },
    },
    [contentTypeIds.smallNewsEntryExternalLink]: {
      linkThumbnail: {
        width: 440,
        height: 440,
      },
    },
    [contentTypeIds.newsEntryArticle]: {
      heroImage: {
        width: 720,
        height: 405,
      },
      largeThumbnail: {
        width: 960,
        height: 563,
      },

      websiteHeroImage: {
        width: 3000,
        height: 600,
      },
    },
    [contentTypeIds.smallNewsEntryArticle]: {
      heroImage: {
        width: 720,
        height: 405,
      },
      smallThumbnail: {
        width: 440,
        height: 440,
      },

      websiteHeroImage: {
        width: 3000,
        height: 600,
      },
    },
    [contentTypeIds.videoBlock]: {
      videoThumbnail: {
        width: 960,
        height: 540,
      },
    },
    [contentTypeIds.newsEntryVideo]: {
      videoThumbnail: {
        width: 960,
        height: 540,
      },
    },
    [contentTypeIds.imageBlock]: {
      image: null,
    },

    [contentTypeIds.newsEntryImage]: {
      imageNewsThumbnail: {
        width: 960,
        height: 563,
      },
    },

    [contentTypeIds.featureBlock]: {
      featureThumbnail: {
        width: 400,
        height: 450,
        fit: "default",
      },
    },
    [contentTypeIds.pollBlock]: {
      option1Image: {
        width: 300,
        height: 400,
      },
      option2Image: {
        width: 300,
        height: 400,
      },
      option3Image: {
        width: 300,
        height: 400,
      },
      option4Image: {
        width: 300,
        height: 400,
      },
      option5Image: {
        width: 300,
        height: 400,
      },
    },
    [contentTypeIds.communityCreator]: {
      communityCreatorThumbnail: {
        width: 50,
        height: 50,
      },
    },

    [contentTypeIds.communityVideoEntry]: {
      communityEntryVideoThumbnail: {
        width: 860,
        height: 482,
      },
    },

    [contentTypeIds.communityLivestreamEntry]: {
      livestreamEntryVideoThumbnail: {
        width: 860,
        height: 482,
      },
    },

    [contentTypeIds.esportRewatchMatchEntry]: {
      matchThumbnail: {
        width: 960,
        height: 540,
      },
      playerOneImage: {
        width: 480,
        height: 540,
      },
      playerTwoImage: {
        width: 480,
        height: 540,
      },
    },
    [contentTypeIds.fullscreenEntryCarousel]: {
      backgroundMedia: {
        width: 960,
        height: 1280,
      },
    },
    [contentTypeIds.carouselEventProgressTrackerEntry]: {
      carouselImage: {
        width: 960,
        height: 764,
      },
      milestone1Image: {
        width: 256,
        height: 256,
      },
      milestone2Image: {
        width: 256,
        height: 256,
      },
      milestone3Image: {
        width: 256,
        height: 256,
      },
      milestone4Image: {
        width: 256,
        height: 256,
      },
      milestone5Image: {
        width: 256,
        height: 256,
      },
      milestone6Image: {
        width: 256,
        height: 256,
      },
      milestone7Image: {
        width: 256,
        height: 256,
      },
      milestone8Image: {
        width: 256,
        height: 256,
      },
    },

    [contentTypeIds.webEvent]: {
      backgroundImage: {
        width: 1170,
        height: 1600,
      },
    },
  },

  availableButtonVariants: [
    "gold",
    "green",
    "red",
    "blue",
    "red-play",
    "purple",
  ],
  progressBarDefaultColor: "#66abf2",

  blogMeta: {
    site: "@clashroyale",
    creator: "@clashroyale",
  },

  activeContentInDays: {
    community: 90,
    news: 90,
    esport: 90,
  },

  supportSmallArticles: true,
  supportEsportRewatchMatchEntry: true,
  supportFullscreenEntries: true,
  supportPolls: true,
  supportTargetPolls: true,
  supportProgressTrackerEntry: true,
  targetingFields: ["country", "countryExclude", "platform", "campaignId"],
  supercellMakeEnabled: true,
  eventPlatformEnabled: true,
  ingameProgressTrackersEnabled: true,
  heroEnabled: true,
};
